module.exports = __webpack_public_path__ + "img/map-color.79a4915d.png";